module.exports={
       BIM_TOKEN:"2326eeb2a0f04d6f886c5bf7127534a9",     // 模型key
       BIM_MODEL_STATUS:true,                            // 是否加载模型
       update_time:localStorage.getItem('update_time'),
       Manpower_CS:[],                                   // 配置参数
       

}